module.exports = __webpack_public_path__ + "static/media/forbes.eafcd6a1.png";